import cloneDeep from 'lodash/cloneDeep'
import extend from 'lodash/extend'
import * as yup from 'yup'

import AddressSchema from './address.field'

const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/


const _fieldPresets = {
	mobile: {
		key: 'mobile',
		label: 'Mobile Number',
		type: 'phone',
		// validator: yup.string().matches(phoneRegExp, 'Phone number is not valid').min(10),

	},
	telephone: {
		key: 'telephone',
		label: 'Phone Number',
		type: 'phone',
		// validator: yup.string().matches(phoneRegExp, 'Phone number is not valid').min(10),

	},
	profileImage: {
		key: 'profileImage',
		label: 'Profile Image',
		type: 'file',
	},
	documents: {
		key: 'documents',
		label: 'Documents',
		type: 'fileArray',
	},
	address: AddressSchema(),
}


export function getPresetFrom(map, key, _props={}) {
	
	var { prefix, ...props } = _props;
	
	if(!map[key])
		throw new Error(`invalid ${map.name} preset ${key}`);

	// clone fieldpreset
	const preset = cloneDeep(map[key]);

	if(typeof prefix === 'string') {
		preset.name = prefix+'.'+preset.name;
	}

	// merge props
	return extend(preset, props);

}

export function getPresetsFrom(map, presets) {
	return presets.map(preset => {
		if(typeof preset === 'string') 
			preset = [preset];
		return getPresetFrom.apply(undefined, [map, ...preset]);
	})
}

export const getFieldPreset = (...args) => getPresetFrom(_fieldPresets, ...args);
export const getFieldPresets = (...args) => getPresetsFrom(_fieldPresets, ...args);

export { AddressSchema }


// WEBPACK FOOTER //
// ./src/modules/resource/fields/index.js